import { FunctionComponent } from 'react';
import { BoardingRatesProvider } from './BoardingRatesProvider';
import BoardingRatesContent from './BoardingRatesContent';

const BoardingRates: FunctionComponent = () => {
    return (
        <BoardingRatesProvider>
            <BoardingRatesContent />
        </BoardingRatesProvider>
    );
};

export default BoardingRates;
